import React from "react";
import Main from "../../Main";
import "./Home.css";
import MyChildHeader from "../MyChild/MyChildHeader";
import MyChildMain from "../MyChild/MyChildMain";
import HomeSidebarLeft from "./HomeSidebarLeft";
import Project from "../Project/Project";
import Inigo from "../../Inigo/Inigo";

const NoChild = () => {
    return <div className="island">...</div>;
};

const Home = props => {
    function displayData(comp) {
        if (props.noChild) {
            return <NoChild />;
        }

        switch (comp) {
            case "MyChildHeader":
                return (
                    <MyChildHeader
                        childrenCount={props.childrenCount}
                        handler={props.handler}
                        prevChild={props.prevChild}
                        nextChild={props.nextChild}
                        sponsorName={props.sponsor.salutation || undefined}
                        childPhoto={props.childPhoto || undefined}
                        child={props.child || undefined}
                    />
                );
            case "MyChildMain":
                return (
                    <MyChildMain
                        child={props.child || undefined}
                        childPhoto={props.childPhoto || undefined}
                    />
                );
            case "Project":
                return (
                    <Project
                        childVideo={props.child.video_url || undefined}
                        childFirstName={props.child.given_name || undefined}
                        project={props.project}
                        // adpVideo={props.child.video_url}
                    />
                );
            default:
                return <NoChild />;
        }
    }

    return (
        <Main>
            <div className="site-home">
                {displayData("MyChildHeader")}
                <div className="donor-body">
                    <div className="row">
                        <div className="donor-left-column col-sm-4 donor-column">
                            <HomeSidebarLeft
                                partner={props.sponsor || undefined}
                                childId={
                                    props.child ? props.child.child_id : null
                                }
                            />
                        </div>
                        <div className="donor-middle-column donor-column col-sm-4">
                            {displayData("MyChildMain")}
                        </div>
                        <div className="donor-right-column donor-column col-sm-4">
                            {displayData("Project")}
                            <Inigo />
                        </div>
                    </div>
                </div>
            </div>
        </Main>
    );
};

export default Home;
